import moment from 'moment'
import campaignsService from '@/api/campaignsService'
import { CAMPAIGN_STATUSES } from '@/utils/campaignOptions'

/**
 *  ActivationCheckHead script file
**/

function getBusinessDaysDiff (d1, d2) {
  const totalDays = d2.diff(d1, 'days') + 1
  let newDay = d1.toDate()
  let workDays = 0
  let saturdays = 0
  let sundays = 0

  for (let i = 0; i < totalDays; i++) {
    const day = newDay.getDay()
    newDay = d1.add(1, 'days').toDate()
    if (day === 0) {
      sundays++
    } else if (day === 6) {
      saturdays++
    } else {
      workDays++
    }
  }

  return { workDays, sundays, saturdays }
}

export default {
  name: 'ActivationCheckHead',
  mixins: [],
  components: {},
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isAccepted: undefined,
      comment: '',
      error: false,
      errorText: '',
      isUpdating: false
    }
  },
  computed: {
    startDateValid () {
      const diff = getBusinessDaysDiff(moment().startOf('day'), moment(this.campaign.start_date))
      return diff.workDays > 1
    },
    isValidCampaign () {
      if (!this.campaign || (this.campaign && !this.campaign.channels.length)) return false
      return this.datesValid(this.campaign) && this.campaign.channels.every(c => { return this.datesValid(c) })
    }
  },
  methods: {
    accept () {
      this.isAccepted = true
    },
    reject () {
      this.isAccepted = false
    },
    send () {
      if (this.isAccepted !== undefined) {
        const newStatus = this.isAccepted ? CAMPAIGN_STATUSES.CENTRAL_ACCEPTED : CAMPAIGN_STATUSES.CENTRAL_REJECTED
        this.isUpdating = true
        campaignsService.updateStatus({
          id: this.campaign.id,
          status: newStatus,
          comment: this.comment || undefined
        }).then(() => {
          this.isUpdating = false
          this.$router.push('/campaigns')
        }).catch(error => {
          if (error.response && error.response.data) this.errorText = error.response.data[0]
          else this.errorText = error
          this.error = true
          this.isUpdating = false
        })
      }
    },
    datesValid (campaign) {
      const existing = campaign.start_date && campaign.finish_date
      const validRange = campaign.start_date < campaign.finish_date
      return existing && validRange && this.startDateValid
    },
    back () {
      this.$emit('back')
    }
  }
}
